export default "__VITE_ASSET__BYM1mEzi__"